import { useEffect, useState } from "react";
import useData from "hooks/useData";
import { useWebmaster } from "features/authentication/hooks/useWebmaster";

export function useEntity(id, bundle, refreshToken = null) {
  const [ entity, setEntity ] = useState();
  const [ isLoading, setIsLoading ] = useState(id);
  const [ error, setError ] = useState('');
  const { getData } = useData();
  const { setEditLink } = useWebmaster();

  // The id can be an id or an alias, in case of an alias the slashed must be removed since
  // Drupal can't handle a route with slashes in it.
  if (id && !Number.isInteger(id)) {
    id = id.replaceAll('/', '::');
  }

  const path = `rest/${ bundle }/${ id }`;

  useEffect(
    () => {
      const load = async () => {
        setIsLoading(true);
        let result;
        try {
          result = await getData(path);
        } catch (exception) {
          console.error(exception);
          setError('De data kon niet worden opgehaald. Ververs de pagina of probeer het later opnieuw.');
        }
        setEntity(result.data);

        setEditLink(result.data?.id);

        setIsLoading(false);
      }

      if (id) {
        load();
      }

      window.scrollTo(0, 0);

      return () => {
        setEditLink(null);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ id, path, refreshToken ]);

  return { entity, isLoading, error };
}

export default useEntity;
